<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg mr-4 mb-4">
    <div
      class="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between"
    >
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Escenario {{ numberToLetter }}
      </h3>
      <svg
        @click="$emit('scenario-removed', number - 1)"
        class="w-6 text-red-400 cursor-pointer hover:text-red-800"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z"
          fill="currentColor"
        />
      </svg>
    </div>
    <div>
      <dl>
        <div
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-sm leading-5 font-medium text-gray-500">
            Puertas
          </dt>
          <dd
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
          >
            <p>
              <span class="text-gray-700">Material:</span>
              {{
                scenario.doors_are_made_of_glass
                  ? 'N/A'
                  : material.doors.filter(
                      (door) => door.id === scenario.doors_material
                    )[0].name
              }}
            </p>
            <p>
              <span class="text-gray-700">Vidrio:</span>
              {{ scenario.doors_are_made_of_glass ? 'Si' : 'No' }}
            </p>
          </dd>
        </div>
        <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm leading-5 font-medium text-gray-500">
            Ventanas
          </dt>
          <dd
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
          >
            <p>
              {{
                material.windows.filter(
                  (window) => window.id === scenario.glass_material
                )[0].name
              }}
            </p>
          </dd>
        </div>
        <div
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-sm leading-5 font-medium text-gray-500">
            Muros
          </dt>
          <dd
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
          >
            <p>
              <span class="text-gray-700">Material:</span>
              {{
                material.walls.filter(
                  (wall) => wall.id === scenario.wall_material
                )[0].name
              }}
            </p>
            <p>
              <span class="text-gray-700">Acabado interior:</span>
              {{
                scenario.wall_interior_finishes === ''
                  ? 'N/A'
                  : material.composite.filter(
                      (composite) =>
                        composite.id === scenario.wall_interior_finishes
                    )[0].name
              }}
            </p>
            <p>
              <span class="text-gray-700">Acabado exterior:</span>
              {{
                scenario.wall_exterior_finishes === ''
                  ? 'N/A'
                  : material.composite.filter(
                      (composite) =>
                        composite.id === scenario.wall_exterior_finishes
                    )[0].name
              }}
            </p>
          </dd>
        </div>
        <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm leading-5 font-medium text-gray-500">
            Losa
          </dt>
          <dd
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
          >
            <p>
              <span class="text-gray-700">Material:</span>
              {{
                material.slabs.filter(
                  (slab) => slab.id === scenario.slab_material
                )[0].name
              }}
            </p>
            <p>
              <span class="text-gray-700">Acabado interior:</span>
              {{
                scenario.slab_interior_finishes === ''
                  ? 'N/A'
                  : material.composite.filter(
                      (composite) =>
                        composite.id === scenario.slab_interior_finishes
                    )[0].name
              }}
            </p>
            <p>
              <span class="text-gray-700">Acabado exterior:</span>
              {{
                scenario.slab_exterior_finishes === ''
                  ? 'N/A'
                  : material.composite.filter(
                      (composite) =>
                        composite.id === scenario.slab_exterior_finishes
                    )[0].name
              }}
            </p>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: {},
    scenario: {},
    material: {},
  },
  computed: {
   numberToLetter: function () {
      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'][this.number - 1];
    },
  },
};
</script>

<style></style>
